//fake NodeJS file system module for opus-media-recorder

export { };